import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import WalletUnlock from "./wallet-unlock"
import { WalletEject } from "./wallet-eject"

interface WalletEjectModalProps {
  children: React.ReactNode;
}

export function WalletEjectModal({ children }: WalletEjectModalProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Export Wallet</DialogTitle>
          <DialogClose />
        </DialogHeader>
        <WalletUnlock>
          <WalletEject />
        </WalletUnlock>
      </DialogContent>
    </Dialog>
  )
}
